define('OutSystems/ClientRuntime/VersionsManager',["require", "exports", "tslib", "./ApplicationInfo", "./ErrorHandling", "./EventDispatcher", "./Exceptions", "./Flow", "./Injector", "./Injector/KnownServices", "./Logger", "./modules/Common/UrlUtils", "./modules/Database/IDatabase", "./modules/Native/Prebundle", "./NativeHelper", "./Navigation", "./Performance", "./RequireManager", "./ResourceCache", "./Settings", "./StorageProvider"], function (require, exports, tslib_1, ApplicationInfo, ErrorHandling, EventDispatcher_1, Exceptions, Flow, Injector_1, KnownServices_1, Logger, UrlUtils_1, IDatabase_1, NativePrebundle, NativeHelper, Navigation, OSPerformance, RequireManager, ResourceCache_1, Settings_1, StorageProvider_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.VersionsManager = exports.getVersionedUrl = exports.buildScriptMap = exports.VersionsManagerStorage = exports.UpgradeStatus = exports.UpgradeFailReason = void 0;
    var VERSIONS_MANAGER_MODULE_NAME = "VersionsManager";
    var INDEX_PAGE_NAME = "index.html";
    var INDEX_NOT_FOUND = -1;
    var CONTENT_HASH_SEPARATOR = "__";
    var UpgradeFailReason;
    (function (UpgradeFailReason) {
        UpgradeFailReason[UpgradeFailReason["Generic"] = 0] = "Generic";
        UpgradeFailReason[UpgradeFailReason["Resources"] = 1] = "Resources";
        UpgradeFailReason[UpgradeFailReason["DataModel"] = 2] = "DataModel";
    })(UpgradeFailReason || (exports.UpgradeFailReason = UpgradeFailReason = {}));
    var UpgradeStatus;
    (function (UpgradeStatus) {
        UpgradeStatus[UpgradeStatus["Idle"] = 0] = "Idle";
        UpgradeStatus[UpgradeStatus["Upgrading"] = 1] = "Upgrading";
        UpgradeStatus[UpgradeStatus["UpgradeSuccess"] = 2] = "UpgradeSuccess";
        UpgradeStatus[UpgradeStatus["UpgradeFailed"] = 3] = "UpgradeFailed";
    })(UpgradeStatus || (exports.UpgradeStatus = UpgradeStatus = {}));
    exports.VersionsManagerStorage = {
        applicationInfo: new StorageProvider_1.StorageObject(StorageProvider_1.StorageType.Persistent, "ApplicationInfo"),
        upgradeStatus: new StorageProvider_1.StorageObject(StorageProvider_1.StorageType.Session, "UpgradeStatus", 0),
    };
    var buildScriptMap = function (resourceMap, versionToken, cdnUrlVersioning, getHomeModuleName, getBasePath) {
        if (cdnUrlVersioning === void 0) { cdnUrlVersioning = false; }
        if (getHomeModuleName === void 0) { getHomeModuleName = ApplicationInfo.getHomeModuleName; }
        if (getBasePath === void 0) { getBasePath = ApplicationInfo.getBasePath; }
        var homeModulePath = "/".concat(getHomeModuleName(), "/");
        var basePath = getBasePath();
        return Object.keys(resourceMap)
            .filter(function (url) { return /\.js$/i.test(url); })
            .reduce(function (map, key) {
            var urlVersionToken = resourceMap[key];
            var url = (0, UrlUtils_1.replaceBasePath)(key, homeModulePath, basePath);
            var urlPathnames = url.split("/");
            var alias = makeModuleAlias(urlPathnames[urlPathnames.length - 1], cdnUrlVersioning);
            if (!map.hasOwnProperty(alias)) {
                map[alias] = (0, UrlUtils_1.buildURLFromVersionedResource)(url, urlVersionToken);
            }
            return map;
        }, {});
    };
    exports.buildScriptMap = buildScriptMap;
    var makeModuleAlias = function (url, cdnUrlVersioning) {
        if (cdnUrlVersioning) {
            var hashSeparatorPos = url.lastIndexOf(CONTENT_HASH_SEPARATOR);
            return hashSeparatorPos !== INDEX_NOT_FOUND ? url.substring(0, hashSeparatorPos) : url.replace(".js", "");
        }
        else {
            return url.replace(".js", "");
        }
    };
    var removeFileExtension = function (filename) {
        var fileExtensionIndex = filename.lastIndexOf(".");
        if (fileExtensionIndex !== INDEX_NOT_FOUND) {
            return filename.substring(0, fileExtensionIndex);
        }
        else {
            return filename;
        }
    };
    var getModuleBasedUrlFromRelativeUrl = function (relativeUrl, homeModuleName) {
        return "/".concat(homeModuleName, "/").concat(relativeUrl);
    };
    var getResourceVersionTokenFromManifest = function (relativeUrl, homeModuleName, urlVersions) { return (urlVersions ? urlVersions[getModuleBasedUrlFromRelativeUrl(relativeUrl, homeModuleName)] : undefined); };
    var findResourceUrl = function (relativeUrl, urlVersions, cdnUrlVersioning) {
        var relativeUrlWithoutExtension = removeFileExtension(relativeUrl);
        var matchedUrlVersions = urlVersions
            ? Object.keys(urlVersions).filter(function (p) { return p.indexOf("".concat(relativeUrlWithoutExtension).concat(CONTENT_HASH_SEPARATOR)) !== INDEX_NOT_FOUND; })
            : [];
        if (cdnUrlVersioning && matchedUrlVersions.length > 0) {
            var lastHashSeparatorPos = matchedUrlVersions[0].lastIndexOf(CONTENT_HASH_SEPARATOR);
            var versionHashAndExtension = matchedUrlVersions[0].substring(lastHashSeparatorPos);
            return "".concat(relativeUrlWithoutExtension).concat(versionHashAndExtension);
        }
        else {
            return relativeUrl;
        }
    };
    var getVersionedUrl = function (relativeUrl, urlVersions, cdnUrlVersioning, getHomeModuleName, getBasePath) {
        if (cdnUrlVersioning === void 0) { cdnUrlVersioning = false; }
        if (getHomeModuleName === void 0) { getHomeModuleName = ApplicationInfo.getHomeModuleName; }
        if (getBasePath === void 0) { getBasePath = ApplicationInfo.getBasePath; }
        var homeModuleName = getHomeModuleName();
        var basePath = getBasePath();
        var resourceUrl = findResourceUrl(relativeUrl, urlVersions, cdnUrlVersioning);
        var versionToken = getResourceVersionTokenFromManifest(resourceUrl, homeModuleName, urlVersions);
        if (versionToken) {
            var urlFromVersionedResource = (0, UrlUtils_1.buildURLFromVersionedResource)(getModuleBasedUrlFromRelativeUrl(resourceUrl, homeModuleName), versionToken !== null && versionToken !== void 0 ? versionToken : "");
            var moduleNameWithSlashes = "/".concat(homeModuleName, "/");
            return (0, UrlUtils_1.replaceBasePath)(urlFromVersionedResource, moduleNameWithSlashes, basePath);
        }
        return resourceUrl;
    };
    exports.getVersionedUrl = getVersionedUrl;
    var VersionsManager = (function () {
        function VersionsManager() {
            this._isAutoUpgradeDisabled = false;
            this.checkedCachedInfoConsistency = false;
        }
        Object.defineProperty(VersionsManager.prototype, "cachedAppInfo", {
            get: function () {
                var appInfo = exports.VersionsManagerStorage.applicationInfo.get();
                if (appInfo) {
                    if (!this.checkedCachedInfoConsistency) {
                        try {
                            VersionsManager.validateApplicationInfo(appInfo);
                        }
                        catch (e) {
                            appInfo = null;
                            exports.VersionsManagerStorage.applicationInfo.remove();
                        }
                        this.checkedCachedInfoConsistency = true;
                    }
                }
                return appInfo;
            },
            set: function (value) {
                exports.VersionsManagerStorage.applicationInfo.set(value);
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(VersionsManager.prototype, "currentAppInfo", {
            get: function () {
                return this.pendingAppInfo ? this.pendingAppInfo : this.cachedAppInfo;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(VersionsManager.prototype, "upgradeStatus", {
            get: function () {
                return exports.VersionsManagerStorage.upgradeStatus.get();
            },
            set: function (value) {
                exports.VersionsManagerStorage.upgradeStatus.set(value);
            },
            enumerable: false,
            configurable: true
        });
        VersionsManager.prototype.initialize = function (initDbPromise, eventHandlers) {
            var _this = this;
            Logger.trace(VERSIONS_MANAGER_MODULE_NAME, "Initializing VersionsManager");
            this.onVersionReady = eventHandlers.onVersionReady || (function () { });
            this.onUpgradeFinished = eventHandlers.onUpgradeFinished || (function (_) { });
            this.onNewVersionDetected =
                (!this.isUpgradeDisabled && eventHandlers.onNewVersionDetected) || (function (_) { return Promise.resolve(null); });
            var onAppInfoReady = eventHandlers.onAppInfoReady || (function (_) { });
            this.initialUpgradeStatus = this.upgradeStatus;
            var homeModuleName = ApplicationInfo.getHomeModuleName();
            if (!homeModuleName) {
                return Promise.reject(Error("Home module not defined!"));
            }
            this.enableBackgroundCheckForNewVersions();
            return this.fetchApplicationManifest().then(function (_a) {
                var manifest = _a.manifest, isFromPrebundle = _a.isFromPrebundle;
                _this.pendingAppInfo = manifest;
                onAppInfoReady(manifest);
                var CDNFilenameVersioning = (0, Settings_1.getEnvParams)().CDNFilenameVersioning;
                RequireManager.configure((0, exports.buildScriptMap)(manifest.manifest.urlVersions, manifest.manifest.versionToken, CDNFilenameVersioning));
                if (_this.isNewVersion(manifest.manifest, isFromPrebundle)) {
                    if (!_this.isUpgradeDisabled && _this.usingStaleIndex(manifest)) {
                        Navigation.reloadCurrentLocation(true);
                        Logger.trace(VERSIONS_MANAGER_MODULE_NAME, "Reloading application - index.html was changed in the server");
                        return false;
                    }
                    _this.upgrade(manifest, initDbPromise);
                }
                else {
                    _this.initDataModel(initDbPromise);
                }
                return true;
            });
        };
        VersionsManager.prototype.initDataModel = function (initDbPromise) {
            var _this = this;
            Logger.trace(VERSIONS_MANAGER_MODULE_NAME, "Initializing data model");
            initDbPromise
                .then(function (db) {
                return _this.upgradeDataModel(db)
                    .then(function () { return _this.switchDataModel(db); })
                    .then(function () {
                    _this.onVersionReady();
                });
            })
                .then(function () { return _this.setUpgradeStatus(0); })
                .catch(function (e) { return _this.handleInitError(e); });
        };
        VersionsManager.prototype.cacheResourcesInBackground = function (appInfoCallback) {
            var _this = this;
            Logger.trace(VERSIONS_MANAGER_MODULE_NAME, "Caching resources in the background...");
            return this.fetchApplicationManifest(false)
                .then(function (_a) {
                var manifest = _a.manifest, isFromPrebundle = _a.isFromPrebundle;
                var isUsingStaleIndex = _this.usingStaleIndex(manifest);
                if (appInfoCallback) {
                    appInfoCallback(isUsingStaleIndex);
                }
                Navigation.forceReloadOnNextNavigation(isUsingStaleIndex);
                if (_this.isNewVersion(manifest.manifest, isFromPrebundle)) {
                    return _this.upgradeResources(manifest);
                }
            })
                .catch(function (e) {
                return Logger.trace(VERSIONS_MANAGER_MODULE_NAME, "Error caching resources for new version in the background: " + e);
            });
        };
        VersionsManager.prototype.getResourceVersionToken = function (relativeUrl, homeModuleName) {
            if (!this.currentAppInfo) {
                return undefined;
            }
            return getResourceVersionTokenFromManifest(relativeUrl, homeModuleName, this.currentAppInfo.manifest.urlVersions);
        };
        VersionsManager.prototype.isNewVersion = function (versionInfo, isFromPrebundle) {
            var versionToken = versionInfo.versionToken;
            var previousVersionToken = this.getLastApplicationVersionToken();
            var hasTokenChanged = versionToken !== previousVersionToken;
            if (this.canDisableNativeAutoUpgrade) {
                var isAutoUpgradeDisabled_1 = this.isAutoUpgradeDisabled;
                var isUpgradable_1 = hasTokenChanged && (!isAutoUpgradeDisabled_1 || isFromPrebundle);
                Logger.trace(this, function () {
                    if (hasTokenChanged) {
                        return "Version check found a new version '".concat(versionToken, "' from ").concat(isFromPrebundle ? "prebundle" : "server", " with auto-upgrade ").concat(isAutoUpgradeDisabled_1 ? "disabled" : "enabled", " and decided it is ").concat(!isUpgradable_1 ? "not " : "", "upgradable. Current version has token '").concat(previousVersionToken, "'");
                    }
                    else {
                        return "Version check found the same version '".concat(versionToken, "'.");
                    }
                });
                return isUpgradable_1;
            }
            else {
                return hasTokenChanged;
            }
        };
        VersionsManager.prototype.getLastApplicationVersionToken = function (allowPendingVersion) {
            if (allowPendingVersion === void 0) { allowPendingVersion = false; }
            if (allowPendingVersion && this.pendingAppInfo) {
                return this.pendingAppInfo.manifest.versionToken;
            }
            var appInfo = this.cachedAppInfo;
            return appInfo ? appInfo.manifest.versionToken : "";
        };
        VersionsManager.prototype.getVersionToken = function (relativeUrl, homeModuleName) {
            return this.getResourceVersionToken(relativeUrl, homeModuleName);
        };
        VersionsManager.prototype.getVersionedUrl = function (relativeUrl) {
            var _a, _b, _c, _d;
            return (0, exports.getVersionedUrl)(relativeUrl, (_b = (_a = this.currentAppInfo) === null || _a === void 0 ? void 0 : _a.manifest) === null || _b === void 0 ? void 0 : _b.urlVersions, (_d = (_c = this.currentAppInfo) === null || _c === void 0 ? void 0 : _c.manifest) === null || _d === void 0 ? void 0 : _d.cdnUrlVersioning);
        };
        VersionsManager.getJSONParseErrorMessage = function (missingFieldName) {
            if (missingFieldName === void 0) { missingFieldName = ""; }
            return ("Error parsing manifest JSON " +
                (missingFieldName ? ", missing or invalid field: ".concat(missingFieldName, ".") : "."));
        };
        VersionsManager.validateApplicationInfo = function (appInfo) {
            if (!appInfo) {
                throw Error(this.getJSONParseErrorMessage());
            }
            if (!appInfo.manifest) {
                throw Error(this.getJSONParseErrorMessage("manifest"));
            }
            var manifest = appInfo.manifest;
            if (!manifest.versionToken || typeof manifest.versionToken !== "string") {
                throw Error(this.getJSONParseErrorMessage("manifest.versionToken"));
            }
            if (!manifest.urlVersions || typeof manifest.urlVersions !== "object") {
                throw Error(this.getJSONParseErrorMessage("manifest.urlVersions"));
            }
            if (!manifest.urlMappings || typeof manifest.urlMappings !== "object") {
                throw Error(this.getJSONParseErrorMessage("manifest.urlMappings"));
            }
            if (!manifest.urlMappingsNoCache || typeof manifest.urlMappingsNoCache !== "object") {
                throw Error(this.getJSONParseErrorMessage("manifest.urlMappingsNoCache"));
            }
            if (!appInfo.data) {
                throw Error(this.getJSONParseErrorMessage("data"));
            }
            var data = appInfo.data;
            if (!data.modules || typeof data.modules !== "object") {
                throw Error(this.getJSONParseErrorMessage("data.modules"));
            }
        };
        VersionsManager.prototype.getLatestVersionFromServer = function () {
            return tslib_1.__awaiter(this, arguments, void 0, function (fromPrefetch) {
                var versionInfo;
                if (fromPrefetch === void 0) { fromPrefetch = false; }
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, ((fromPrefetch && OSManifestLoader.prefetchedVersion) ||
                                OSManifestLoader.getLatestVersion({ sendEnvParam: (0, Settings_1.getEnvParams)().SendEnvParamOnManifestRequest }))];
                        case 1:
                            versionInfo = _a.sent();
                            if (this.canDisableNativeAutoUpgrade) {
                                this._isAutoUpgradeDisabled = versionInfo.isAutoUpgradeDisabled;
                            }
                            return [2, versionInfo];
                    }
                });
            });
        };
        VersionsManager.prototype.checkForNewVersion = function () {
            var _this = this;
            if (this.isUpgradeDisabled || this.isUpgradingVersion || !exports.VersionsManagerStorage.applicationInfo.isDefined()) {
                return;
            }
            this.getLatestVersionFromServer(false).then(function (versionInfo) {
                if (_this.getLastApplicationVersionToken() !== versionInfo.versionToken && !_this.isAutoUpgradeDisabled) {
                    _this.onNewVersionDetected(false, _this.isAutoUpgradeDisabled);
                }
            }, function (error) {
                Logger.trace(VERSIONS_MANAGER_MODULE_NAME, "Error checking for new version: " + error);
            });
        };
        VersionsManager.prototype.upgrade = function (appInfo, initDbPromise) {
            var _this = this;
            Logger.trace(VERSIONS_MANAGER_MODULE_NAME, "New application version detected, starting upgrade...");
            this.setUpgradeStatus(1);
            var resourcesUpgrade = this.supportsResourceCache().then(function (cache) {
                return cache
                    ? _this.upgradeResources(appInfo).catch(function (e) {
                        return _this.handleUpgradeError(e, 1, Promise.resolve(undefined));
                    })
                    : Promise.resolve();
            });
            var dataModelUpgrade = initDbPromise
                .then(function (db) { return _this.upgradeDataModel(db); })
                .catch(function (e) { return _this.handleUpgradeError(e, 2, resourcesUpgrade); });
            Promise.all([resourcesUpgrade, dataModelUpgrade])
                .then(function () {
                if (_this.upgradeStatus !== 1) {
                    return;
                }
                _this.commitNewVersion(appInfo, initDbPromise).then(function (success) {
                    if (success) {
                        _this.onVersionReady();
                    }
                });
            })
                .catch(function (e) { return _this.handleUpgradeError(e); });
        };
        VersionsManager.prototype.supportsResourceCache = function () {
            return tslib_1.__awaiter(this, void 0, void 0, function () {
                var hasSplashScreen, isSWAvailable, useCache;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!ApplicationInfo.isWebApplication()) return [3, 1];
                            hasSplashScreen = !!ApplicationInfo.getHomeModuleDefinition().splashScreenName;
                            Logger.trace(VERSIONS_MANAGER_MODULE_NAME, "Web app - Resource pre-caching is ".concat(hasSplashScreen ? "enabled" : "disabled"));
                            return [2, hasSplashScreen];
                        case 1: return [4, this.serviceWorkerIsAvailable()];
                        case 2:
                            isSWAvailable = _a.sent();
                            useCache = NativeHelper.isRunningOnNative() || !isSWAvailable;
                            Logger.trace(VERSIONS_MANAGER_MODULE_NAME, "Mobile app - Pre-caching resources with ".concat(useCache ? "Resource Cache" : "Service Worker"));
                            return [2, useCache];
                    }
                });
            });
        };
        VersionsManager.prototype.serviceWorkerIsAvailable = function () {
            return tslib_1.__awaiter(this, void 0, void 0, function () {
                var r, e_1;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 2, , 3]);
                            if (!("serviceWorker" in navigator)) {
                                return [2, false];
                            }
                            return [4, navigator.serviceWorker.getRegistrations()];
                        case 1:
                            r = _a.sent();
                            return [2, r !== null];
                        case 2:
                            e_1 = _a.sent();
                            return [2, false];
                        case 3: return [2];
                    }
                });
            });
        };
        VersionsManager.prototype.commitNewVersion = function (appInfo, initDbPromise) {
            var _this = this;
            return initDbPromise
                .then(function (db) { return _this.switchDataModel(db); })
                .then(function () { return _this.switchResourcesVersion(appInfo.manifest.versionToken); })
                .then(function () {
                var isFirstVersion = !_this.cachedAppInfo;
                _this.cachedAppInfo = appInfo;
                _this.setUpgradeStatus(isFirstVersion ? 0 : 2);
                return true;
            });
        };
        VersionsManager.prototype.upgradeResources = function (appInfo) {
            OSPerformance.start("VersionsManager upgradeResources");
            return Flow.tryFinally(function () { return ResourceCache_1.ResourceCache.start(appInfo.manifest); }, function () { return OSPerformance.end("VersionsManager upgradeResources"); });
        };
        VersionsManager.prototype.upgradeDataModel = function (db) {
            var _this = this;
            OSPerformance.start("VersionsManager upgradeDataModel");
            if ((0, IDatabase_1.instanceOfIDatabase)(db)) {
                Logger.trace(VERSIONS_MANAGER_MODULE_NAME, "Initializing data model on IndexedDB database.");
                return Flow.tryFinally(function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                    var entityModules, dbService, _i, entityModules_1, entityModule;
                    return tslib_1.__generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4, this.getAllEntityModules()];
                            case 1:
                                entityModules = _a.sent();
                                dbService = Injector_1.default.resolve(KnownServices_1.ServiceNames.EntityService);
                                for (_i = 0, entityModules_1 = entityModules; _i < entityModules_1.length; _i++) {
                                    entityModule = entityModules_1[_i];
                                    dbService.registerInitializer(entityModule.getEntityInfos());
                                }
                                return [4, db.initialize()];
                            case 2:
                                _a.sent();
                                return [2];
                        }
                    });
                }); }, function () { return OSPerformance.end("VersionsManager upgradeDataModel"); });
            }
            else {
                Logger.trace(VERSIONS_MANAGER_MODULE_NAME, "Initializing data model on SQLite/WebSQL database.");
                return Flow.tryFinally(function () { return _this.doForEachClientEntitiesModule(db, function (runner, module) { return module.init(runner); }); }, function () { return OSPerformance.end("VersionsManager upgradeDataModel"); });
            }
        };
        VersionsManager.prototype.getAllEntityModules = function () {
            var requirePromises = [];
            var clientEntitiesModules = ApplicationInfo.getClientEntitiesModules();
            if (clientEntitiesModules) {
                var _loop_1 = function (entityModuleName) {
                    Logger.trace(VERSIONS_MANAGER_MODULE_NAME, "Fetching entity module '".concat(entityModuleName, "'."));
                    requirePromises.push(new Promise(function (resolve, reject) {
                        RequireManager.loadModule([entityModuleName], function (entityModule) { return resolve(entityModule); }, reject);
                    }));
                };
                for (var _i = 0, clientEntitiesModules_1 = clientEntitiesModules; _i < clientEntitiesModules_1.length; _i++) {
                    var entityModuleName = clientEntitiesModules_1[_i];
                    _loop_1(entityModuleName);
                }
            }
            return Promise.all(requirePromises);
        };
        VersionsManager.prototype.doForEachClientEntitiesModule = function (db, action) {
            if (db.isMock) {
                return Promise.resolve();
            }
            return this.getAllEntityModules().then(function (allEntityModules) {
                return db.executeTransaction(function (runner) {
                    return runner
                        .feed(null)
                        .andThenAll(function (runner) {
                        return allEntityModules.map(function (module) { return function (runner) {
                            return action(runner, module);
                        }; });
                    });
                });
            });
        };
        VersionsManager.prototype.switchResourcesVersion = function (versionToken) {
            ResourceCache_1.ResourceCache.switch(versionToken);
        };
        VersionsManager.prototype.switchDataModel = function (db) {
            if ((0, IDatabase_1.instanceOfIDatabase)(db)) {
                Logger.trace(VERSIONS_MANAGER_MODULE_NAME, "Finishing initialization of data model on IndexedDB database.");
                return db.initializerCleanup();
            }
            else {
                Logger.trace(VERSIONS_MANAGER_MODULE_NAME, "Finishing initialization of data model on SQLite/WebSQL database.");
                return this.doForEachClientEntitiesModule(db, function (runner, module) { return module.switch(runner); });
            }
        };
        VersionsManager.prototype.handleInitError = function (error) {
            var errorMessage = this.isUpgradeDisabled
                ? "Upgrade failed and rollback isn't possible at this time"
                : "Unable to load the data model";
            Logger.error(VERSIONS_MANAGER_MODULE_NAME, errorMessage, error);
            ErrorHandling.handleError(error);
        };
        VersionsManager.prototype.handleUpgradeError = function (error, reason, resourcesPromise) {
            if (reason === void 0) { reason = 0; }
            if (resourcesPromise === void 0) { resourcesPromise = Promise.resolve(undefined); }
            if (Exceptions.isInstanceOf(error, Exceptions.Exceptions.OpenDatabaseException)) {
                Logger.error(VERSIONS_MANAGER_MODULE_NAME, "Upgrade failed - unable to open the database.", error);
                ErrorHandling.handleError(error);
                return Promise.resolve(undefined);
            }
            if (!Navigation.hasPendingReload() && this.initialUpgradeStatus !== 3) {
                Logger.error(VERSIONS_MANAGER_MODULE_NAME, "Upgrade failed - rolling back to previous application version.", error);
                return this.rollBackApplicationVersion(reason, resourcesPromise);
            }
            else if (this.initialUpgradeStatus === 3) {
                ErrorHandling.handleError(error);
                return Promise.resolve(undefined);
            }
            else {
                Logger.trace(VERSIONS_MANAGER_MODULE_NAME, "Upgrade failed - ignoring error due to concurrent navigation.");
                if (this.upgradeStatus !== 3) {
                    this.setUpgradeStatus(0);
                }
                return Promise.resolve(undefined);
            }
        };
        Object.defineProperty(VersionsManager.prototype, "isUpgradingVersion", {
            get: function () {
                return this.upgradeStatus === 1;
            },
            enumerable: false,
            configurable: true
        });
        VersionsManager.prototype.setUpgradeStatus = function (status, failReason) {
            if (failReason === void 0) { failReason = 0; }
            this.upgradeStatus = status;
            Logger.trace(VERSIONS_MANAGER_MODULE_NAME, "Upgrade status changed to: " + status);
            if (status === 2) {
                return this.onUpgradeFinished(true);
            }
            else if (status === 3) {
                return this.onUpgradeFinished(false, failReason);
            }
        };
        VersionsManager.prototype.rollBackApplicationVersion = function (reason, resourcesPromise) {
            var _this = this;
            return this.loadCachedManifest()
                .then(function (_a) {
                var manifest = _a.manifest;
                _this.setUpgradeStatus(3, reason);
                if (reason === 1) {
                    return;
                }
                return resourcesPromise.then(function () { return ResourceCache_1.ResourceCache.start(manifest.manifest); });
            })
                .then(function () {
                Navigation.reloadApplication(false);
            })
                .catch(function (err) {
                ErrorHandling.handleError(err);
            });
        };
        Object.defineProperty(VersionsManager.prototype, "isUpgradeDisabled", {
            get: function () {
                return this.upgradeStatus === 3;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(VersionsManager.prototype, "isAutoUpgradeDisabled", {
            get: function () {
                return this._isAutoUpgradeDisabled;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(VersionsManager.prototype, "canDisableNativeAutoUpgrade", {
            get: function () {
                return (0, Settings_1.getEnvParams)().CanDisableAutoUpgrade && NativeHelper.isRunningOnNative() && this.isRunningCachedIndex();
            },
            enumerable: false,
            configurable: true
        });
        VersionsManager.prototype.isRunningCachedIndex = function () {
            var screenIndexVersion = OSManifestLoader.indexVersionToken;
            var cachedIndexVersion = this.getIndexVersion(this.cachedAppInfo);
            return !!cachedIndexVersion && screenIndexVersion === cachedIndexVersion;
        };
        VersionsManager.prototype.usingStaleIndex = function (appInfo) {
            if (Navigation.currentLocationHasTimestamp()) {
                return false;
            }
            var cachedIndexVersion = OSManifestLoader.indexVersionToken || this.getIndexVersion(this.cachedAppInfo);
            var mostRecentIndexVersion = this.getIndexVersion(appInfo);
            return cachedIndexVersion !== mostRecentIndexVersion;
        };
        VersionsManager.prototype.getIndexVersion = function (appInfo) {
            if (!appInfo) {
                return "";
            }
            var versionToken = getResourceVersionTokenFromManifest(INDEX_PAGE_NAME, ApplicationInfo.getHomeModuleName(), appInfo.manifest.urlVersions);
            if (versionToken) {
                return versionToken.substring(1);
            }
            return "";
        };
        VersionsManager.prototype.loadCachedManifest = function () {
            return tslib_1.__awaiter(this, void 0, void 0, function () {
                var prebundleManifestPromise, cacheManifestPromise, prebundledManifest, cachedManifest, cachedManifestError, error_1, error_2, error_3, manifest;
                var _a;
                return tslib_1.__generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            if (!this.canDisableNativeAutoUpgrade) return [3, 11];
                            prebundleManifestPromise = this.innerLoadPrebundledManifest();
                            cacheManifestPromise = this.innerLoadCachedManifest();
                            prebundledManifest = null;
                            cachedManifest = null;
                            cachedManifestError = null;
                            _b.label = 1;
                        case 1:
                            _b.trys.push([1, 3, , 4]);
                            return [4, prebundleManifestPromise];
                        case 2:
                            prebundledManifest = _b.sent();
                            return [3, 4];
                        case 3:
                            error_1 = _b.sent();
                            Logger.trace(this, "Error loading prebundled manifest: ".concat((_a = error_1 === null || error_1 === void 0 ? void 0 : error_1.message) !== null && _a !== void 0 ? _a : error_1));
                            return [3, 4];
                        case 4:
                            _b.trys.push([4, 6, , 7]);
                            return [4, cacheManifestPromise];
                        case 5:
                            cachedManifest = _b.sent();
                            return [3, 7];
                        case 6:
                            error_2 = _b.sent();
                            cachedManifestError = error_2;
                            return [3, 7];
                        case 7:
                            _b.trys.push([7, 9, , 10]);
                            return [4, this.innerLoadCachedManifest()];
                        case 8:
                            cachedManifest = _b.sent();
                            return [3, 10];
                        case 9:
                            error_3 = _b.sent();
                            cachedManifestError = error_3;
                            return [3, 10];
                        case 10:
                            if (!prebundledManifest || !prebundledManifest.manifest.versionSequence) {
                                if (cachedManifest) {
                                    return [2, { manifest: cachedManifest, isFromPrebundle: false }];
                                }
                                else {
                                    throw cachedManifestError;
                                }
                            }
                            if (!cachedManifest) {
                                return [2, { manifest: prebundledManifest, isFromPrebundle: true }];
                            }
                            return [2, cachedManifest.manifest.versionSequence >= prebundledManifest.manifest.versionSequence
                                    ? { manifest: cachedManifest, isFromPrebundle: false }
                                    : { manifest: prebundledManifest, isFromPrebundle: true }];
                        case 11: return [4, this.innerLoadCachedManifest()];
                        case 12:
                            manifest = _b.sent();
                            return [2, { manifest: manifest, isFromPrebundle: false }];
                    }
                });
            });
        };
        VersionsManager.prototype.innerLoadCachedManifest = function () {
            return tslib_1.__awaiter(this, void 0, void 0, function () {
                var appInfo;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, this.ensureCachedManifest()];
                        case 1:
                            _a.sent();
                            if (!this.cachedAppInfo) return [3, 2];
                            return [2, this.cachedAppInfo];
                        case 2: return [4, OSManifestLoader.getCachedManifest({
                                sendEnvParam: (0, Settings_1.getEnvParams)().SendEnvParamOnManifestRequest,
                            })];
                        case 3:
                            appInfo = (_a.sent());
                            VersionsManager.validateApplicationInfo(appInfo);
                            return [2, appInfo];
                    }
                });
            });
        };
        VersionsManager.prototype.innerLoadPrebundledManifest = function () {
            return NativePrebundle.getManifest();
        };
        VersionsManager.prototype.ensureCachedManifest = function () {
            if (NativeHelper.isRunningOnNative() || this.cachedAppInfo) {
                return Promise.resolve(undefined);
            }
            else {
                this.setUpgradeStatus(0);
                return Promise.reject(new Error("No cached manifest found. It's not possible to rollback to a previous version."));
            }
        };
        VersionsManager.prototype.getLatestManifestFromServer = function (versionToken) {
            return tslib_1.__awaiter(this, void 0, void 0, function () {
                var appInfo;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, OSManifestLoader.getLatestManifest(versionToken, {
                                sendEnvParam: (0, Settings_1.getEnvParams)().SendEnvParamOnManifestRequest,
                            })];
                        case 1:
                            appInfo = _a.sent();
                            VersionsManager.validateApplicationInfo(appInfo);
                            return [2, { manifest: appInfo, isFromPrebundle: false }];
                    }
                });
            });
        };
        VersionsManager.prototype.fetchApplicationManifest = function (fromPrefetch) {
            var _this = this;
            if (fromPrefetch === void 0) { fromPrefetch = true; }
            OSPerformance.start("VersionsManager fetchApplicationManifest");
            if (this.isUpgradeDisabled) {
                return this.loadCachedManifest();
            }
            else {
                return this.getLatestVersionFromServer(fromPrefetch)
                    .then(function (versionInfo) {
                    return _this.isNewVersion(versionInfo, false)
                        ? _this.getLatestManifestFromServer(versionInfo.versionToken)
                        : _this.loadCachedManifest();
                })
                    .catch(function () { return _this.loadCachedManifest(); })
                    .then(function (appInfo) {
                    OSPerformance.end("VersionsManager fetchApplicationManifest");
                    return appInfo;
                });
            }
        };
        VersionsManager.prototype.enableBackgroundCheckForNewVersions = function () {
            var _this = this;
            var isNavigating = false;
            EventDispatcher_1.EventDispatcher.listen(EventDispatcher_1.EventType.NavigationStart, function () { return (isNavigating = true); });
            EventDispatcher_1.EventDispatcher.listen(EventDispatcher_1.EventType.TransitionEnd, function () {
                isNavigating = false;
                setTimeout(function () {
                    if (!isNavigating) {
                        _this.checkForNewVersion();
                    }
                }, 1000);
            });
        };
        return VersionsManager;
    }());
    exports.VersionsManager = VersionsManager;
    var Instance = new VersionsManager();
    exports.default = Instance;
});
//# sourceMappingURL=VersionsManager.js.map;
